import { IntNumberInput } from "@/shared/components/domain/qpm/inputs/number-input";
import { Label } from "@/shared/components/ui/label";
import { useQpmMonitorVisitsMutation } from "@/services/backend/qpm/monitors/api/monitor-api";

export function MonitorVisitsComponent({
  monitorId,
  value,
}: {
  monitorId: string;
  value: number;
}) {
  const [update] = useQpmMonitorVisitsMutation();

  return (
    <div className="grid gap-1.5 sm:grid-cols-4">
      <Label className="sm:col-span-2" htmlFor="recommended-visits">
        Empfohlene Maßnahmen/Jahr
      </Label>
      <div className="min-w-0 sm:col-span-2">
        <IntNumberInput
          className=""
          id="recommended-visits"
          value={value}
          onBlur={(val: number) => update({ id: monitorId, perYear: val })}
        />
      </div>
    </div>
  );
}
